import { $generateHtmlFromNodes } from '@lexical/html'
import { type SerializedEditorState } from 'lexical'
import { createEmailEditor } from '../nodes'
import { $getEmailNode } from '../nodes/EmailNode'
import { $subjectText, EMAIL_EXPORT } from './exportMap'
import { applyFallbacks } from './fallbacks'

export interface CompiledEmail {
  subject: string
  body: string
}

export const compileEmail = (state: SerializedEditorState): CompiledEmail => {
  const editor = createEmailEditor({ namespace: 'email-export', html: { export: EMAIL_EXPORT } })
  editor.setEditorState(editor.parseEditorState(JSON.stringify(state)))
  return editor.read(() => {
    const variables = $getEmailNode()?.getVariables() ?? []
    return { subject: applyFallbacks($subjectText(), variables), body: applyFallbacks($generateHtmlFromNodes(editor, null), variables) }
  })
}

export type CompileResult = { ok: true; email: CompiledEmail } | { ok: false; message: string }

export const tryCompileEmail = (state: SerializedEditorState): CompileResult => {
  try {
    return { ok: true, email: compileEmail(state) }
  } catch (error) {
    return { ok: false, message: error instanceof Error ? error.message : String(error) }
  }
}
